// Action Types
export const FETCH_USERS_REQUEST = "FETCH_USERS_REQUEST";
export const FETCH_USERS_SUCCESS = "FETCH_USERS_SUCCESS";
export const FETCH_USERS_FAILURE = "FETCH_USERS_FAILURE";

export const FETCH_LOCATIONS_REQUEST = "FETCH_LOCATIONS_REQUEST";
export const FETCH_LOCATIONS_SUCCESS = "FETCH_LOCATIONS_SUCCESS";
export const FETCH_LOCATIONS_FAILURE = "FETCH_LOCATIONS_FAILURE";

export const CREATE_USER_REQUEST = "CREATE_USER_REQUEST";
export const CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS";
export const CREATE_USER_FAILURE = "CREATE_USER_FAILURE";

export const UPDATE_USER_REQUEST = "UPDATE_USER_REQUEST";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UPDATE_USER_FAILURE = "UPDATE_USER_FAILURE";

export const DELETE_USER_REQUEST = "DELETE_USER_REQUEST";
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";
export const DELETE_USER_FAILURE = "DELETE_USER_FAILURE";

export const UPDATE_LOCATION_REQUEST = "UPDATE_LOCATION_REQUEST";
export const UPDATE_LOCATION_SUCCESS = "UPDATE_LOCATION_SUCCESS";
export const UPDATE_LOCATION_FAILURE = "UPDATE_LOCATION_FAILURE";

export const ASSIGN_ROLES_LOCATIONS_REQUEST = "ASSIGN_ROLES_LOCATIONS_REQUEST";
export const ASSIGN_ROLES_LOCATIONS_SUCCESS = "ASSIGN_ROLES_LOCATIONS_SUCCESS";
export const ASSIGN_ROLES_LOCATIONS_FAILURE = "ASSIGN_ROLES_LOCATIONS_FAILURE";

export const UPDATE_NOTIFICATION_SETTINGS = "UPDATE_NOTIFICATION_SETTINGS";

// Action Creators
export const fetchUsersRequest = (searchParams = {}) => ({
  type: FETCH_USERS_REQUEST,
  payload: searchParams,
});

export const fetchUsersSuccess = (users) => ({
  type: FETCH_USERS_SUCCESS,
  payload: users,
});

export const fetchUsersFailure = (error) => ({
  type: FETCH_USERS_FAILURE,
  payload: error,
});

export const fetchLocationsRequest = () => ({
  type: FETCH_LOCATIONS_REQUEST,
});

export const fetchLocationsSuccess = (locations) => ({
  type: FETCH_LOCATIONS_SUCCESS,
  payload: locations,
});

export const fetchLocationsFailure = (error) => ({
  type: FETCH_LOCATIONS_FAILURE,
  payload: error,
});

export const createUserRequest = () => ({
  type: CREATE_USER_REQUEST,
});

export const createUserSuccess = (user) => ({
  type: CREATE_USER_SUCCESS,
  payload: user,
});

export const createUserFailure = (error) => ({
  type: CREATE_USER_FAILURE,
  payload: error,
});

export const updateUserRequest = () => ({
  type: UPDATE_USER_REQUEST,
});

export const updateUserSuccess = (user) => ({
  type: UPDATE_USER_SUCCESS,
  payload: user,
});

export const updateUserFailure = (error) => ({
  type: UPDATE_USER_FAILURE,
  payload: error,
});

export const deleteUserRequest = (userId) => ({
  type: DELETE_USER_REQUEST,
  payload: userId,
});

export const deleteUserSuccess = (userId) => ({
  type: DELETE_USER_SUCCESS,
  payload: userId,
});

export const deleteUserFailure = (error) => ({
  type: DELETE_USER_FAILURE,
  payload: error,
});

export const updateLocationRequest = () => ({
  type: UPDATE_LOCATION_REQUEST,
});

export const updateLocationSuccess = (location) => ({
  type: UPDATE_LOCATION_SUCCESS,
  payload: location,
});

export const updateLocationFailure = (error) => ({
  type: UPDATE_LOCATION_FAILURE,
  payload: error,
});

export const assignRolesLocationsRequest = (data) => ({
  type: ASSIGN_ROLES_LOCATIONS_REQUEST,
  payload: data,
});

export const assignRolesLocationsSuccess = (result) => ({
  type: ASSIGN_ROLES_LOCATIONS_SUCCESS,
  payload: result,
});

export const assignRolesLocationsFailure = (error) => ({
  type: ASSIGN_ROLES_LOCATIONS_FAILURE,
  payload: error,
});

export const updateNotificationSettings = (settings) => ({
  type: UPDATE_NOTIFICATION_SETTINGS,
  payload: settings,
});

// Initial State
const initialState = {
  users: [],
  locations: [],
  admin_emails: [],
  admin_phone_numbers: [],
  last_search_term: "",
  notificationSettings: {
    smsEnabled: true,
    emailEnabled: true,
    pushEnabled: false,
  },
  loading: {
    users: false,
    locations: false,
    createUser: false,
    updateUser: false,
    deleteUser: false,
    updateLocation: false,
  },
  error: {
    users: null,
    locations: null,
    createUser: null,
    updateUser: null,
    deleteUser: null,
    updateLocation: null,
  },
};

// Reducer
const settingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USERS_REQUEST:
      return {
        ...state,
        loading: { ...state.loading, users: true },
        error: { ...state.error, users: null },
        last_search_term: (action.payload?.search_term || "").toString().trim(),
        ui_search_term: (action.payload?.search_term || "").toString(),
      };

    case FETCH_USERS_SUCCESS:
      return {
        ...state,
        users: action.payload,
        loading: { ...state.loading, users: false },
      };

    case FETCH_USERS_FAILURE:
      return {
        ...state,
        loading: { ...state.loading, users: false },
        error: { ...state.error, users: action.payload },
      };

    case FETCH_LOCATIONS_REQUEST:
      return {
        ...state,
        loading: { ...state.loading, locations: true },
        error: { ...state.error, locations: null },
      };

    case FETCH_LOCATIONS_SUCCESS:
      return {
        ...state,
        locations: action.payload,
        loading: { ...state.loading, locations: false },
      };

    case FETCH_LOCATIONS_FAILURE:
      return {
        ...state,
        loading: { ...state.loading, locations: false },
        error: { ...state.error, locations: action.payload },
      };

    case CREATE_USER_REQUEST:
      return {
        ...state,
        loading: { ...state.loading, createUser: true },
        error: { ...state.error, createUser: null },
      };

    case CREATE_USER_SUCCESS:
      return {
        ...state,
        users: [...state.users, action.payload],
        loading: { ...state.loading, createUser: false },
      };

    case CREATE_USER_FAILURE:
      return {
        ...state,
        loading: { ...state.loading, createUser: false },
        error: { ...state.error, createUser: action.payload },
      };

    case UPDATE_USER_REQUEST:
      return {
        ...state,
        loading: { ...state.loading, updateUser: true },
        error: { ...state.error, updateUser: null },
      };

    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        users: state.users.map((user) =>
          user.id === action.payload.id ? action.payload : user
        ),
        loading: { ...state.loading, updateUser: false },
      };

    case UPDATE_USER_FAILURE:
      return {
        ...state,
        loading: { ...state.loading, updateUser: false },
        error: { ...state.error, updateUser: action.payload },
      };

    case DELETE_USER_REQUEST:
      return {
        ...state,
        loading: { ...state.loading, deleteUser: true },
        error: { ...state.error, deleteUser: null },
      };

    case DELETE_USER_SUCCESS:
      return {
        ...state,
        users: state.users.filter((user) => user.id !== action.payload),
        loading: { ...state.loading, deleteUser: false },
      };

    case DELETE_USER_FAILURE:
      return {
        ...state,
        loading: { ...state.loading, deleteUser: false },
        error: { ...state.error, deleteUser: action.payload },
      };

    case UPDATE_LOCATION_REQUEST:
      return {
        ...state,
        loading: { ...state.loading, updateLocation: true },
        error: { ...state.error, updateLocation: null },
      };

    case UPDATE_LOCATION_SUCCESS:
      return {
        ...state,
        locations: state.locations.map((location) =>
          location.id === action.payload.id ? action.payload : location
        ),
        loading: { ...state.loading, updateLocation: false },
      };

    case UPDATE_LOCATION_FAILURE:
      return {
        ...state,
        loading: { ...state.loading, updateLocation: false },
        error: { ...state.error, updateLocation: action.payload },
      };

    case ASSIGN_ROLES_LOCATIONS_REQUEST:
      return {
        ...state,
        loading: { ...state.loading, assignRoles: true },
        error: { ...state.error, assignRoles: null },
      };

    case ASSIGN_ROLES_LOCATIONS_SUCCESS:
      return {
        ...state,
        // Assuming the result includes updated users/locations or a success message
        // For now, we'll just return the state as is, or update specific parts if needed
        loading: { ...state.loading, assignRoles: false },
      };

    case ASSIGN_ROLES_LOCATIONS_FAILURE:
      return {
        ...state,
        loading: { ...state.loading, assignRoles: false },
        error: { ...state.error, assignRoles: action.payload },
      };

    case UPDATE_NOTIFICATION_SETTINGS:
      return {
        ...state,
        notificationSettings: {
          ...state.notificationSettings,
          ...action.payload,
        },
      };

    // Notification admin contacts
    case "SET_ADMIN_EMAILS":
      return {
        ...state,
        admin_emails: Array.isArray(action.payload) ? action.payload : [],
      };

    case "SET_ADMIN_PHONES":
      return {
        ...state,
        admin_phone_numbers: Array.isArray(action.payload)
          ? action.payload
          : [],
      };

    default:
      return state;
  }
};

// Selectors
export const selectUsers = (state) => state.settings.users;
export const selectLocations = (state) => state.settings.locations;
export const selectNotificationSettings = (state) =>
  state.settings.notificationSettings;
export const selectSettingsLoading = (state) => state.settings.loading;
export const selectSettingsError = (state) => state.settings.error;

export default settingsReducer;
